import Modal from 'shared/components/Modal'

const ConfirmModal = ({ onClose, onCancel, onConfirm }) => (
    <Modal
        header={<T>nps.admin.create.survey.confirmation.modal.title</T>}
        onClose={onClose}
        buttons={[
            {
                btnStyle: 'outline',
                onClick: onCancel,
                label: <T>nps.admin.create.survey.confirmation.modal.cancel.btn.label</T>,
                btnClassName: 'mr-1',
            },
            {
                btnStyle: 'primary',
                onClick: onConfirm,
                label: <T>nps.admin.create.survey.confirmation.modal.confirm.btn.label</T>,
            },
        ]}></Modal>
)

export default ConfirmModal
